// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { useNavigate } from 'react-router-dom';

/**
 * Landing page shown to JIT-provisioned advisors whose brokerage has
 * advisor_jit_provisioning_mode = REQUIRE_ADMIN_APPROVAL.
 *
 * Reached by AuthenticatedRoute when /api/sso/provision-self returns
 * status=pending_activation. The advisor's session is still valid; we
 * just gate access to the platform until an admin activates them.
 */
export default function AwaitingApprovalPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f6f7f9',
        padding: '2rem',
      }}
    >
      <div
        style={{
          maxWidth: 520,
          width: '100%',
          background: '#fff',
          borderRadius: 8,
          padding: '2rem',
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        }}
      >
        <h1 style={{ marginTop: 0 }}>Awaiting administrator approval</h1>
        <p>
          You've signed in successfully, but your account is waiting for a
          brokerage administrator to activate it.
        </p>
        <p>
          This is a one-time step for new advisors at your brokerage. You'll
          receive an email once you've been activated; come back and sign in
          again at that point.
        </p>
        <p style={{ color: '#666', marginTop: '2rem' }}>
          If you've been waiting longer than expected, contact your brokerage
          administrator directly.
        </p>
        <button
          type="button"
          onClick={() => {
            window.location.href = '/login?reason=logout';
          }}
          style={{
            marginTop: '1rem',
            padding: '0.5rem 1rem',
            background: '#0066cc',
            color: '#fff',
            border: 'none',
            borderRadius: 4,
            cursor: 'pointer',
          }}
        >
          Sign out
        </button>
        <button
          type="button"
          onClick={() => navigate(0)}
          style={{
            marginTop: '1rem',
            marginLeft: '0.5rem',
            padding: '0.5rem 1rem',
            background: '#fff',
            color: '#0066cc',
            border: '1px solid #0066cc',
            borderRadius: 4,
            cursor: 'pointer',
          }}
        >
          Check again
        </button>
      </div>
    </div>
  );
}
